export const HeaventHeaders = {
    ApiKey: 'x-heavent-api-key',
    CommitSha: 'x-heavent-commit-sha',
    MontreuxApiKey: 'x-heavent-montreux-api-key',
    NewVersion: 'x-heavent-new-version',
    UserId: 'x-heavent-user-id',
    UserToken: 'x-user-token',
    ZapierApiKey: 'x-heavent-zapier-api-key'
};
